import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=3347cba4&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=3347cba4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3347cba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3347cba4')) {
      api.createRecord('3347cba4', component.options)
    } else {
      api.reload('3347cba4', component.options)
    }
    module.hot.accept("./MenuItem.vue?vue&type=template&id=3347cba4&scoped=true&", function () {
      api.rerender('3347cba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/MenuItem.vue"
export default component.exports